import { Injectable } from '@angular/core';

function getWindow(): Window {
    return window;
}

@Injectable({
    providedIn: 'root',
})
export class WindowReferenceService {
    public get nativeWindow(): Window {
        return getWindow();
    }
}
